import { uploaderConfigsMap } from '@frameio/graphql-client/client-schema/transfers/uploader-configs';
import type { UploaderConfigEnum } from '@frameio/graphql-client/generated';
import { getDevFlag } from '@frameio/shared/dev-flags';
import type { UploaderConfig } from './configs';
import { UploaderConfigSettings } from './configs';

const isUploaderConfigOverridesFeatureFlagEnabled = getDevFlag(
  'UPLOADER_CONFIG_OVERRIDES'
);

const updatedConfigs: UploaderConfig = UploaderConfigSettings;

if (isUploaderConfigOverridesFeatureFlagEnabled) {
  (Object.keys(UploaderConfigSettings) as Array<UploaderConfigEnum>).forEach(
    (key: UploaderConfigEnum) => {
      updatedConfigs[key] = UploaderConfigSettings[key];
      const customValue = uploaderConfigsMap.get(key);
      if (customValue) {
        updatedConfigs[key].value = customValue;
      }
    }
  );
}

export { updatedConfigs as UploaderConfigs };
